import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { Usuario } from '../../shared';

declare var $: any;

@Component({
  selector: 'app-editar-pin',
  templateUrl: './editar-pin.component.html',
  styleUrls: ['./editar-pin.component.css']
})
export class EditarPinComponent implements OnInit {

  @Input() statusFatores: any = {};
  @Input() regex: string = "";
  @Input() descricaoRegex: string = "";
  @Output() enviaMensagemSucesso = new EventEmitter();
  public usuario: Usuario;
  public confirm: string;
  public errorMessage: string;
  public pinAtual: string;
  public novoPin: string;
  public confirmaPin: string;
  public novoCodigoChave: string;
  public disabledSalvarSubmit: boolean = false;

  @ViewChild('formEditarPIN', { static: true }) formEditar;

  constructor(private usuarioService: UsuarioService) { 

  }

  ngOnInit() {
    this.usuario = JSON.parse(localStorage.getItem("currentUser"));
  }
  
  onSubmit() {
    this.disabledSalvarSubmit = true;
    this.usuario.senha = this.pinAtual;
    this.usuario.changePassword = this.novoPin;

    this.usuarioService.alterarPin(this.usuario).subscribe(
      () => {
        this.resetFormEditar();
        this.enviaMensagemSucesso.emit('PIN alterado com sucesso.');
        $('#modalEditarPIN').modal('hide');
      },
      err => {
        this.disabledSalvarSubmit = false;
        this.errorMessage = err.message;
      }
    );
  }

  resetFormEditar() {
    this.formEditar.resetForm();
    this.disabledSalvarSubmit = false;
    this.errorMessage = null;
  }  
}